import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const StatusUnknown = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='StatusUnknown' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M2,3.99079514 C2,2.89130934 2.89821238,2 3.99079514,2 L20.0092049,2 C21.1086907,2 22,2.89821238 22,3.99079514 L22,20.0092049 C22,21.1086907 21.1017876,22 20.0092049,22 L3.99079514,22 C2.89130934,22 2,21.1017876 2,20.0092049 L2,3.99079514 Z M12,15 L12,14 C12,13 12,12.5 13,12 C14,11.5 15,11 15,9.5 C15,8.5 14,7 12,7 C10,7 9,8.26413718 9,10 M12,16 L12,18' />
  </StyledIcon>
);
